// extracted by mini-css-extract-plugin
export default {"price":"E7-z","priceRow":"F7-z","onSale":"G7-z","msrpLabelPrice":"H7-z","msrpLabel":"I7-z","originalPrice":"J7-z","percentOff":"K7-z"};